module.exports = "/images/vendor/flag-icon-css/flags/1x1/me.svg?2d0c8f786f51dfee2fb550733ff65db0";